import { render, staticRenderFns } from "./UserProductsList.vue?vue&type=template&id=09c7dd9c&"
import script from "./UserProductsList.vue?vue&type=script&lang=js&"
export * from "./UserProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports